import { LngLatBounds } from 'mapbox-gl';

export default class lngLatBounds {
  #bounds
  constructor(latitude, longitude) {
    this._createBounds({ lat: latitude, lng: longitude });
  }

  _createBounds() {
    this.#bounds = new LngLatBounds();
  }

  add(latLng) {
    this.#bounds.extend(latLng);
  }

  get() {
    return this.#bounds;
  }
}
